import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const registerSoils = async (companyId, groupIds) => {
  return await axios.post('company-soils ', {companyId, groupIds})
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default registerSoils;